import { CourseFilters } from './CourseFilters';

export default CourseFilters;
